import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 3H3v18h7v2h2V1h-2v2zm0 15H5l5-6v6zM21 3h-7v2h5v13l-5-6v9h7V3z"
}), 'CompareSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CompareSharp.js
// module id = 2906
// module chunks = 2